import { registerDe } from '../i18n/index.js';

registerDe({
  'Organisations': 'Organisationen',
  'loading…': 'wird geladen…',
  'with an open deal': 'mit offenem Geschäft',
  'clients': 'Kundinnen',
  'New organisation': 'Neue Organisation',
  '{name} created': '{name} erstellt',
  'Could not create the organisation.': 'Die Organisation konnte nicht erstellt werden.',
  'organisations on the record, not archived': 'erfasste Organisationen, nicht archiviert',
  'Monitored': 'Überwacht',
  'registry, website and news monitors arrive in milestone M5': 'Register-, Website- und News-Monitore kommen mit Meilenstein M5',
  'Open deals': 'Offene Geschäfte',
  'face value': 'Nominalwert',
  'Signals · 7d': 'Signale · 7 T',
  'no monitor has run yet': 'noch kein Monitor gelaufen',
  'With a signal': 'Mit Signal',
  'monitors in all': 'Monitore insgesamt',
  'runs in 24h': 'Läufe in 24 h',
  'the monitors could not be read': 'die Monitore konnten nicht gelesen werden',
  'waiting for a decision': 'warten auf eine Entscheidung',
  'Clients': 'Kundinnen',
  'linked to Signet engagements': 'mit Signet-Mandaten verknüpft',
  'All organisations': 'Alle',
  'Active': 'Aktiv',
  'Dormant': 'Ruhend',
  'Name, UID, domain…': 'Name, UID, Domain…',
  'No organisation matches this filter.': 'Keine Organisation passt zu diesem Filter.',
  'No organisation has been recorded yet. Add one, or run the seed import.': 'Es ist noch keine Organisation erfasst. Erfassen Sie eine, oder führen Sie den Seed-Import aus.',
  'Name': 'Name',
  '{n} person': '{n} Person', '{n} people': '{n} Personen',
  'no open deal': 'kein offenes Geschäft',
  'client': 'Kundin',

  // ── round 4: the duplicate finder. It proposes; Review decides. ──
  'Find duplicates': 'Dubletten suchen',
  'Looking…': 'wird gesucht…',
  'Look for organisation rows that are the same organisation. It proposes; nothing merges without a click in Review.':
    'Nach Organisationszeilen suchen, die dieselbe Organisation sind. Es wird nur vorgeschlagen; ohne Klick in der Prüfung wird nichts zusammengeführt.',
  '{n} pairs proposed · {m} already decided · {k} pending in Review':
    '{n} Paare vorgeschlagen · {m} bereits entschieden · {k} in der Prüfung offen',
  'The duplicate finder could not run. Nothing was proposed.':
    'Die Dublettensuche konnte nicht laufen. Es wurde nichts vorgeschlagen.',

  // ── the units on a board row ──
  '{n} unit': '{n} Einheit',
  '{n} units': '{n} Einheiten',
  '{n} in this tree, units included': '{n} in diesem Baum, Einheiten eingeschlossen',
}, 'OrganisationsPage');
